<template>
  <div>
    <van-nav-bar :border="true" left-arrow @click-left="toEducationalPoints">
      <template #title>
        <h3>积分申请</h3>
      </template>
      <template #right>
        <font class="applyfont">可用积分：{{ pointSum }}</font>
      </template>
    </van-nav-bar>
    <!-- 积分申请注意事项 -->
    <van-notice-bar :text="noticeMsg" left-icon="volume-o" @click="changeWrapable" />
    <!-- 申请对象 -->
    <!-- <van-field
      v-if="$store.getters.point_admin_power === '2'"
      v-model="aplicationobject"
      class="margin-t10"
      label="申请对象"
      readonly
      is-link
      required
      @click="aplicationobjectshow=true"
    />
    <van-action-sheet
      v-model="aplicationobjectshow"
      :actions="searchalluserdata"
      :round="false"
      :close-on-click-action="true"
      @select="SetAplicationObject"
    >
      <template #description>
        <van-search v-model="search" placeholder="请输入搜索关键词" />
      </template>
    </van-action-sheet> -->
    <!-- 报销金额 申请积分-->
    <!-- :style="$store.getters.point_admin_power !== '2' ? 'margin-top: 10px': ''" -->
    <van-cell-group
      class="margin-t1"
      style="margin-top: 10px"
    >
      <van-row>
        <van-col span="12">
          <van-field
            v-model="reimbursementamount"
            type="number"
            label="报销金额"
            required
            accept
            :disabled="flg==='TableData'? true : false"
            @input="SetReimbursementAmount(reimbursementamount)"
          />
        </van-col>
        <van-col span="12">
          <van-field
            v-model="applypoints"
            :disabled="applypointsdisabled"
            type="number"
            label="申请积分"
            required
          />
        </van-col>
      </van-row>
    </van-cell-group>
    <!-- 申请类型 -->
    <van-field
      v-model="aplicationtypename"
      label="申请类型"
      readonly
      is-link
      required
      :disabled="flg==='TableData'? true : false"
      @click="flg==='TableData'? aplicationtypeshow=false :aplicationtypeshow=true"
    />
    <van-action-sheet
      v-model="aplicationtypeshow"
      :actions="aplicationtypedata"
      :round="false"
      :close-on-click-action="true"
      @select="SetAplicationType"
    />
    <!-- 申请说明 -->
    <van-field
      v-model="applicationdescription"
      rows="2"
      autosize
      label="申请说明"
      type="textarea"
      maxlength="50"
      placeholder="请输入申请说明"
      required
      show-word-limit
      :disabled="flg==='TableData'? true : false"
    />
    <!-- 上传凭证 -->
    <van-field name="uploader" label="文件上传">
      <template #input>
        <van-uploader
          v-model="uploader"
          max-count="3"
          :before-read="beforeRead"
          :disabled="flg==='TableData'? true : false"
          :deletable="flg==='TableData'? false : true"
        />
      </template>
    </van-field>
    <!-- pdf -->
    <van-field
      v-if="$store.getters.point_admin_power === '1' && flg === 'TableData'"
      name="pdf"
      label="pdf"
    >
      <template #input>
        <pdf
          v-for="(i, index) in pdfSrc"
          :key="index"
          :src="i.url"
          @click.native="pdfyl(pdfSrc[index])"
        />
      </template>
    </van-field>
    <!-- 审核人 -->
    <van-field
      v-model="reviewertext"
      label="审核人"
      readonly
      is-link
      required
      :disabled="flg==='TableData'? true : false"
      @click="flg==='TableData'? reviewershow=false : reviewershow=true "
    />
    <van-action-sheet
      v-model="reviewershow"
      :actions="reviewerdata"
      :round="false"
      :close-on-click-action="true"
      @select="SetReviewer"
    />
    <!-- 审批同意拒绝 -->
    <examinebutton v-if="flg === 'TableData'" />
    <!-- 更新按钮 -->
    <updatebutton v-else-if="flg === 'modify'" @updatebutton="toEducationalPoints()" />
    <!-- 申请积分按钮 -->
    <applybuttons v-else @EducationalPoint="toEducationalPoints()" />
    <!-- <van-overlay :show="show" @click="show = false">
      <div ref="pdfRef" :style="{ height:windowHeight,width:'100%' }" />
    </van-overlay> -->
    <van-popup v-model="popupNoticeMsg" style="padding: 20px; width: 80%">{{ noticeMsg }}</van-popup>
    <van-overlay :show="show" @click="show = false">
      <div ref="pdfRef" :style="{ height:windowHeight,width:'100%' }" />
    </van-overlay>
  </div>
</template>
<script>
import { GetPointSum, GetAllUser, GetApprovalUser, DownloadFileMobile } from '@/api/EducationalPoints'
import applybuttons from './ApplyButton'
import examinebutton from './ExamineButton'
import updatebutton from './UpdateButton'
import { Notify } from 'vant'
import pdf from 'vue-pdf'
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
export default {
  name: 'EducationalPointsApply',
  components: { applybuttons, examinebutton, [Notify.Component.name]: Notify.Component, updatebutton, pdf },
  data() {
    return {
      // 可用积分
      pointSum: '0',
      // 积分申请注意事项
      noticeMsg: '申请规则：购书时，请上传明细类发票(包含具体书籍名称及数量)如所购买的书籍不符合员工教育积分使用范围，则申请不予通过',
      // 申请对象
      aplicationobject: this.$store.getters.username + '(' + this.$store.getters.usercode + ')',
      // 申请对象show
      aplicationobjectshow: false,
      // 全部在职人员
      allUser: [],
      // 全部在职人员检索框
      search: '',
      // 报销金额
      reimbursementamount: '',
      // 申请积分
      applypoints: '',
      applypointsdisabled: true,
      // 申请类型
      aplicationtypename: '',
      // 申请类型id
      aplicationtypeid: '',
      // 申请类型show
      aplicationtypeshow: false,
      // 申请类型data
      aplicationtypedata: [{ id: '3', name: '购买书类' }, { id: '2', name: '培训相关' }],
      // 申请说明
      applicationdescription: '',
      // 上传凭证
      uploader: [],
      // 审核人
      reviewertext: '',
      // 审核人ID
      reviewerid: '',
      // 审核人name
      reviewername: '',
      // 审核人show
      reviewershow: false,
      // 审核人data
      reviewerdata: [],
      data: [],
      flg: '',
      id: '',
      approval_status: '',
      windowHeight: document.documentElement.clientHeight,
      pdfSrc: [],
      show: false
    }
  },
  computed: {
    // 申请对象 匹配搜索
    searchalluserdata: function() {
      return this.allUser.filter(value => value.id.indexOf(this.search) !== -1 || value.name.indexOf(this.search) !== -1)
    }
  },
  watch: {
    dataLeaveType: function() {
      this.noticeMsg = this.GLOBAL.BASE_CREATE_NOTICEMSG[this.dataLeaveType]
    }
  },
  created() {
    this.data = this.$route.params.data
    this.flg = this.$route.params.flg
    // 审批详细
    if (this.flg === 'TableData') {
      // 获取当前可用积分数
      this.getPointSum(this.data.user_id)
      // 清空上传凭证
      this.uploader = []
      // 获取图片
      if (this.data.img1_addr_name !== '') {
        this.downloadFile(this.data.img1_addr_name)
      }
      if (this.data.img2_addr_name !== '') {
        this.downloadFile(this.data.img2_addr_name)
      }
      if (this.data.img3_addr_name !== '') {
        this.downloadFile(this.data.img3_addr_name)
      }
      // 报销金额
      this.reimbursementamount = this.data.money
      // 申请积分
      this.applypoints = this.data.score
      // 申请类型
      this.aplicationtypename = this.data.apply_type === '3' ? '购买书类' : '培训相关'
      // 申请说明
      this.applicationdescription = this.data.content
      // 批准者名称
      this.reviewertext = this.data.approval_user_name + '(' + this.data.approval_user_id + ')'
    // 修改积分申请页面
    } else if (this.flg === 'modify') {
      // 获取当前可用积分数
      this.getPointSum(this.data.user_id)
      // 编号
      this.id = this.data.id
      // 清空上传凭证
      this.uploader = []
      // 获取图片1
      if (this.data.img1_addr_name !== '') {
        this.downloadFile(this.data.img1_addr_name)
      }
      // 获取图片2
      if (this.data.img2_addr_name !== '') {
        this.downloadFile(this.data.img2_addr_name)
      }
      // 获取图片3
      if (this.data.img3_addr_name !== '') {
        this.downloadFile(this.data.img3_addr_name)
      }
      // 报销金额
      this.reimbursementamount = this.data.money
      // 申请积分
      this.applypoints = this.data.score
      // 申请类型
      this.aplicationtypename = this.data.apply_type === '3' ? '购买书类' : '培训相关'
      this.aplicationtypeid = this.data.apply_type
      // 申请说明
      this.applicationdescription = this.data.content
      // 批准者名称（工号）
      this.reviewertext = this.data.approval_user_name + '(' + this.data.approval_user_id + ')'
      // 批准者id
      this.reviewerid = this.data.approval_user_id
      // 批准者姓名
      this.reviewername = this.data.approval_user_name
    } else {
      // 获取当前可用积分数
      this.getPointSum(this.$store.getters.usercode)
    }
    // 获取全部在职人员
    this.getAllUser()
    // 获取审批人
    this.getApprovalUser()
  },
  mounted() {
  },
  methods: {
    changeWrapable() {
      if (this.noticeMsg === '') return
      this.popupNoticeMsg = true
    },
    pdfyl(val) {
      this.show = true
      new Pdfh5(this.$refs.pdfRef, {
        pdfurl: val.url,
        scrollEnable: true,
        zoomEnable: true,
        scale: 0.6
      })
    },
    // 申请对象
    SetAplicationObject(item) {
      this.aplicationobject = item.name
      // 获取指定人员可用积分
      this.getPointSum(item.id)
    },
    // 申请类型
    SetAplicationType(item) {
      this.aplicationtypeid = item.id
      this.aplicationtypename = item.name
    },
    // 审核人
    SetReviewer(item) {
      this.reviewertext = item.name
      this.reviewerid = item.id
      this.reviewername = item.param_name
    },
    // 获取全部在职人员
    getAllUser() {
      const that = this
      GetAllUser(function(res) {
        if (res.code === 0) {
          const value = JSON.parse(JSON.parse(res.data))
          var newArr = value.map(item => ({
            id: item.user_code,
            name: item.user_name + '(' + item.user_code + ')'
          }))
          that.allUser = newArr
        } else {
          that.allUser = []
        }
      })
    },
    // 获取审批人
    getApprovalUser() {
      const that = this
      GetApprovalUser(function(res) {
        if (res.code === 0) {
          const value = JSON.parse(res.data)
          var newArr = value.map(item => ({
            id: item.user_id,
            name: item.user_name + '(' + item.user_id + ')',
            param_name: item.user_name
          }))
          that.reviewerdata = newArr
        } else {
          that.reviewerdata = []
        }
      })
    },
    // 获取当前可用积分数
    getPointSum(user_id) {
      const that = this
      GetPointSum({ user_id: user_id }, function(res) {
        if (res.code === 0) {
          that.pointSum = JSON.parse(res.data)[0].result
        } else {
          that.pointSum = 0
        }
      })
    },
    // 申请积分
    SetReimbursementAmount(val) {
      const r = /^[0]+[0-9]*$/
      if (r.test(val)) {
        this.reimbursementamount = val.replace(/^[0]+[0-9]*$/gi, '')
      } else {
        this.applypoints = parseInt('-' + Math.ceil(val))
      }
    },
    // 返回EducationalPoints
    toEducationalPoints() {
      // to审批一览
      if (this.flg === 'TableData') {
        this.$router.push(
          { path: '/' }
        )
        this.$store.dispatch('pointvuex/point_to', '1')
      // 再申请
      } else if (this.flg === 'modify') {
        this.$router.push(
          { path: 'index/EducationalPoints' }
        )
      // to积分一览
      } else {
        this.$router.push(
          { path: 'index/EducationalPoints' }
        )
      }
      this.$store.dispatch('pointvuex/point_list', '0')
    },
    // 上传jpg/png
    beforeRead(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
        return true
      } else {
        Notify({ type: 'warning', message: '请上传 jpg/ png格式文件', duration: 2500 })
        return false
      }
    },
    downloadFile(img_addr_name) {
      const that = this
      DownloadFileMobile({ filePath: img_addr_name }, function(res) {
        // pdf文件
        if (res.indexOf('data:application/pdf;base64') !== -1) {
          that.pdfSrc.push({ url: res, img_name: img_addr_name })
        // 图片文件
        } else {
          that.uploader.push({ url: res, isImage: true, img_name: img_addr_name })
          img_addr_name = ''
        }
      })
    }
  }
}
</script>
<style scoped lang="css">
  .applyfont{
    margin-left: 10px;
    font-size: 11pt;
  }
  .van-card{
    background-color:#ffffff;
    border-radius:20px;
    margin: 10px 5px 10px 5px;
    padding: 6px;
  }
  .margin-t10{
    margin-top: 10px;
  }
  .margin-t1{
    margin-top: -1px;
  }
</style>
